/* @flow */
/* eslint-disable babel/no-invalid-this */
import safeAccess from "safe-access";
import type { SensorFeature } from "./types";

function Sensor(feature: SensorFeature) {
  if (this._sensorFeatures == null) {
    this._sensorFeatures = {};
  }

  // assuming at most one of each sensor type...
  this._sensorFeatures[feature.sensor_type] = feature;

  this.getSensorTypes = () => {
    return _.keys(this._sensorFeatures);
  };

  this.hasSensorType = (sensorType) => {
    return this._sensorFeatures[sensorType] != null;
  };

  this.getSensorValue = (sensorType) => {
    let sensor = this._sensorFeatures[sensorType];
    return safeAccess(sensor, "value");
  };

  this.getSensorDisplayValue = (sensorType) => {
    let sensor = this._sensorFeatures[sensorType];
    if (sensor == null || sensor.value == null) {
      return null;
    }
    let unit = sensor.unit || "";
    if (/^[A-Za-z]+$/.test(unit)) {
      return `${sensor.value} ${unit}`;
    } else {
      return `${sensor.value}${unit}`;
    }
  };

  let attrs = {};
  if (feature.status != null) {
    attrs.status = feature.status;
  }

  return attrs;
}

// not meant to be an exhaustive list of sensor types, just of ones that the
// app refers to specifically
Sensor.Type = {
  OUTDOOR_TEMPERATURE: "Outdoor Temperature",
  RELATIVE_HUMIDITY: "Relative Humidity",
  SMOKE: "Smoke",
  TEMPERATURE: "Temperature",
};

export default Sensor;



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/sensor.js